import $ from "jquery";

$(document).ready(function ($) {
  function getSliderSettings(slides, center) {
    if (center == 1) {
      center = true;
    } else {
      center = false;
    }
    if (slides > 4) {
      var slidesLarge = slides - 1;
      var slidesMed = slides - 2;
    } else if (slides <= 2) {
      var slidesLarge = 2;
      var slidesMed = 2;
    }
    return {
      slidesToShow: slides,
      centerMode: center,
      centerPadding: "15%",
      arrows: true,
      responsive: [
        {
          breakpoint: 1160,
          settings: {
            slidesToShow: slidesLarge,
          },
        },
        {
          breakpoint: 991,
          settings: {
            slidesToShow: slidesMed,
          },
        },
        {
          breakpoint: 768,
          centerPadding: "50px",
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    };
  }

  // Reset slider on filter change
  $(".c-blog-slider__categories a").on("click", function (e) {
    e.preventDefault();

    var category = $(this).parent().attr("data-id");
    $(".c-blog-slider__categories a").removeClass("active");
    $(this).addClass("active");

    var data = {
      action: "belizefilter",
      category: category,
      nonce: travelbelize_scripts_params.security,
      perPage: travelbelizePostSlides,
    };

    $.ajax({
      url: travelbelize_scripts_params.ajaxurl,
      data: data,
      type: "POST",
      beforeSend: function () {},
      success: function (response) {
        var data = $.parseJSON(response);
        $(".c-blog-slider__posts").html(data[0]);
        var slides = data[1];
        if (slides >= 4) {
          slides = 2;
        }
        $(".c-blog-slider__posts ul").slick(getSliderSettings(slides, true));

        $(
          ".c-blog-slider__posts .slick-slide[data-slick-index='-1'] li"
        ).addClass("faded");
        $(".faded *").each(function () {
          $(this).addClass("faded");
        });

        setTimeout(function () {
          $(
            ".c-blog-slider__posts .slick-slide[data-slick-index='0'] li"
          ).addClass("faded");
          $(".faded *").each(function () {
            $(this).addClass("faded");
          });
        }, 250);

        setTimeout(function () {
          $(".c-blog-slider__posts .slick-slide li").addClass("faded");
          $(".faded *").each(function () {
            $(this).addClass("faded");
          });
        }, 500);

        jQuery(".c-blog-slider__posts ul").on("setPosition", function () {
          jQuery(this).find(".slick-slide").height("auto");
          var slickTrack = jQuery(this).find(".slick-track");
          var slickTrackHeight = jQuery(slickTrack).height();
          jQuery(this)
            .find(".slick-slide")
            .css("height", slickTrackHeight + "px");
        });
      },
    });
    return false;
  });
});
